<template>
  <v-dialog
    scrollable
    width="538px"
    :value="true"
    @click:outside="$emit('close')"
  >
    <v-card class="pa-0 ma-0"
      ><v-card-title class="px-6 pt-4 pb-3 text-h6">{{
        $t('problem_solving.improve.corrective_action_assignee_trigger')
      }}</v-card-title>

      <v-card-text class="px-6 pt-1 pb-0">
        <v-form v-model="isFormValid">
          <AssigneesSelector
            required
            multiple
            hideLabel
            :selectedAccountIds="newAssignees"
            :disabled="isLoading"
            :validationRules="validationRules"
            @change="handleAssigneesChange"
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 py-4 justify-end">
        <Button
          plain
          :disabled="isLoading"
          :text="$t('common.button.cancel')"
          @click="$emit('close')"
        />
        <Button
          color="primary"
          :loading="isLoading"
          :disabled="disableSave"
          :text="$t('common.apply')"
          @click="handleAddAssignees"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import mixin from '@/mixins/mixin.vue'

import Button from '@/components/UI/Button'
import AssigneesSelector from '@/components/AssigneesSelector/AssigneesSelector.vue'

export default {
  name: 'BulkAddAssigneesModal',

  mixins: [mixin],

  props: {
    selectedFindings: {
      type: Array,
      default() {
        return []
      },
    },
    selectedTeamId: String,
    siteId: String,
  },

  components: {
    AssigneesSelector,
    Button,
  },

  data() {
    return {
      newAssignees: [],
      isFormValid: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters(['organizationId']),

    disableSave() {
      return this.isLoading || !this.isFormValid
    },

    findingWithMoreAssignees() {
      return this.selectedFindings.reduce((prev, current) => {
        return prev.assignees.length > current.assignees.length ? prev : current
      })
    },

    validationRules() {
      return [
        items => items.length > 0 || this.$t('routines.min_assignees_error'),
        items => {
          const maxAssignees =
            this.$constants.routines.assignees.maxLength -
            this.findingWithMoreAssignees.assignees.length

          return (
            items.length <= maxAssignees ||
            (maxAssignees === this.$constants.routines.assignees.maxLength
              ? this.$t('routines.maximum_assignees', {
                  maxAssignees: this.$constants.routines.assignees.maxLength,
                })
              : this.$t('routines.maximum_bulk_assignees_error', {
                  findingName: this.findingWithMoreAssignees.situation,
                  totalExistingAssignees: this.findingWithMoreAssignees
                    .assignees.length,
                  maxAssignees: this.$constants.routines.assignees.maxLength,
                }))
          )
        },
      ]
    },
  },

  methods: {
    handleAssigneesChange(assignees) {
      this.newAssignees = assignees
    },

    async getTeam() {
      try {
        const response = await api.teams.getTeamById(
          this.organizationId,
          this.selectedTeamId
        )
        return response.data
      } catch (err) {
        this.handleRequestError(err)
      }
    },

    async handleAddAssignees() {
      try {
        this.isLoading = true
        const findingsToEdit = this.selectedFindings.map(element => element._id)
        await api.findings.bulkAddAssignees({
          organizationId: this.organizationId,
          findingsIds: findingsToEdit,
          assignees: this.newAssignees,
        })
        this.showSuccess(
          this.$t('routines.findings_bulk_edit_success', {
            count: findingsToEdit.length,
          })
        )
        this.$emit('success', { totalNewAssignees: this.newAssignees.length })
      } catch (err) {
        this.handleRequestError(err)
        this.$emit('close')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
